module.exports = __webpack_public_path__ + "img/big_tree_light.de615cd0.png";